<script lang="ts">
  import Login from "@/components/login.svelte";
  import { Col, Container, Row } from "sveltestrap";
  import Spacer from "../components/spacer.svelte";
</script>

<Spacer />

<footer id="footer">
  <Container>
    <div class="pc">
      <Row>
        <Col xs="auto">
          <img
            id="footer-logo"
            src="/images/ci/nare-white.png"
            class="my-3"
            alt="나래트랜드 CI"
          />
        </Col>
        <Col>
          <div id="copyright" class="position-relative">
            <div class="top-50 position-absolute translate-middle-y">
              경기도 부천시 부흥로 303번길 36(중동, 금호프라자 507호)<br />
              회사명: 주식회사 나래트랜드 | 대표이사: 최승욱 | 사업자등록번호 : 130-86-84324<br
              />
              이메일: naretrends02@naver.com | 대표번호: 032.662.5000<br />
              2022 NARE All rights reserved.
              <Login />
            </div>

            <div class="copyitem">
              <Row class="justify-content-end">
                <Col xs="3" sm="3" class="text-center">
                  <div class="family_logo">
                    <a href="http://www.naretrends.com/"
                      ><img
                        src="/images/main/family_logo_nr_w.png"
                        style="margin-top: 20px; margin-right: 14px; margin-left: 0px;"
                        alt="패밀리1"
                      /></a
                    >
                  </div>
                </Col>
                <Col xs="3" sm="3" class="text-center">
                  <div class="family_logo">
                    <a href="http://www.farmnote.org/"
                      ><img
                        src="/images/main/family_logo_fn_w.png"
                        style="margin-top: 20px; margin-right: -5px; margin-left: 0px;"
                        alt="패밀리2"
                      /></a
                    >
                  </div>
                </Col>
                <Col xs="3" sm="3" class="text-center">
                  <div class="family_logo">
                    <a href="https://farmfuture.cafe24.com/"
                      ><img
                        src="/images/main/family_logo_gp_w.png"
                        style="margin-top: 20px; margin-right: -30px; margin-left: 0px;"
                        alt="패밀리3"
                      /></a
                    >
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div
      class="mobile"
      style="
    width: 29%;
"
    >
      <img
        id="footer-logo"
        style="margin-top: 0px !important; margin-bottom: 0px !important;"
        src="/images/ci/nare-white.png"
        class="my-3 svelte-16gwrj0"
        alt="나래트랜드 CI"
      />
    </div>
    <div
      class="mobile"
      style="
    color: white;
    font-size: 10px;
"
    >
      경기도 부천시 부흥로 303번길 36(중동, 금호프라자 507호)<br />
      회사명: 주식회사 나래트랜드 | 대표이사: 최승욱 | 사업자등록번호 : 130-86-84324<br
      />
      이메일: naretrends02@naver.com | 대표번호: 032.662.5000<br />
      2022 NARE All rights reserved.
      <button class="svelte-ju9jep">관리자 로그인</button>
    </div>
  </Container>
</footer>

<style lang="scss">
  footer {
    width: 100%;
    height: 165px;
    background: #392a28;
    border-top: 1px solid rgb(255, 255, 255);

    #footer-logo {
      width: 12rem;
    }

    #copyright {
      height: 100%;
      color: white;
      font-size: 0.8rem;
    }
  }
  .copyitem {
    float: right;
    display: block;
    margin-top: 2rem;
  }
  .family_logo {
    display: inline-block;
    margin-right: 1.5rem;
  }
</style>
